import { IAppState } from '../common/state';
import { selectEmptyState } from './results/selectEmptyState';

/**
 * Признак того, что теги применённых фильтров показывает блок пустой выдачи на хосте.
 * В этом случае микрофронт фильтров прячет свой блок тегов, чтобы они не дублировались,
 * а хост убирает с выдачи всё между заголовком и блоком.
 */
export function selectIsEmptyStateWithTags(state: IAppState): boolean {
  const emptyState = selectEmptyState(state);

  return state.results.offers.length === 0 && Boolean(emptyState?.tags?.length);
}
